export const expectedExpression = 'Expected a JavaScript expression';
export const expectedParen = 'Expected closing paren';
